<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="$router.push({ name: 'gestoesDeAulas' })"
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Vínculo
        </h1>
      </v-col>
    </v-row>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)" :disabled="submittingForm" class="pa-4">
        <v-row class="pl-2 rounded-lg">
          <v-col cols="12" md="6" lg="8">
            <ValidationProvider name="Professor" rules="required" v-slot="{ errors }">
              <e-label>Professor</e-label>
              <e-autocomplete
                :items="professoresList"
                :return-object="false"
                :item-value="(value) => value.id"
                :item-text="(val) => `${val.cpf} - ${val.nome} - ${val.user.roles[0].name}`"
                :error-messages="errors"
                :loading="carregandoProfessores"
                v-model="form.instrutor_id"
                label="Selecione uma opção"
                dense
                solo
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <ValidationProvider name="Tipo" rules="required" v-slot="{ errors }">
              <e-label>Tipo do Professor</e-label>
              <v-select
                :items="tipos"
                :item-value="(value) => value.id"
                :item-text="(val) => val.descricao"
                label="Selecione uma opção"
                v-model="form.tipo_professor"
                :error-messages="form.errors ? form.errors : errors"
                dense
                solo
              ></v-select>
            </ValidationProvider>
          </v-col>
        </v-row>
        <v-row
          class="animate__animated animate__zoomIn mb-6 pa-2 rounded-lg elevation-1"
          style="animation-duration: 0.5s"
          v-for="relacao of relacoes"
          :key="relacoes.indexOf(relacao)"
        >
          <v-col cols="8" md="6" lg="3">
            <ValidationProvider name="Turma" rules="required" v-slot="{ errors }">
              <e-label>Turma</e-label>
              <e-autocomplete
                :items="turmasList"
                :return-object="false"
                :item-value="(value) => value.id"
                :item-text="(val) => val.descricao"
                :error-messages="relacao.errors ? relacao.errors : errors"
                :loading="carregandoTurmas"
                v-model="relacao.turma_id"
                :disabled="editing"
                @change="onChangeTurma(relacao)"
                label="Selecione uma opção"
                dense
                solo
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="2" md="4" lg="2">
            <v-container class="" fluid>
              <v-switch
                v-model="relacao.is_polivalencia"
                label="Polivalência"
                @change="onChangePolivalencia(relacao)"
              />
            </v-container>
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <ValidationProvider
              v-if="!relacao.is_polivalencia"
              name="Disciplina"
              :rules="!relacao.is_polivalencia && !editing ? 'required' : ''"
              v-slot="{ errors }"
            >
              <e-label>Componentes Curriculares</e-label>
              <e-autocomplete
                :items="disciplinasList"
                :return-object="false"
                :item-value="(value) => value.id"
                :item-text="(val) => val.descricao"
                :error-messages="relacao.errors ? relacao.errors : errors"
                :loading="carregandoDisciplinas"
                v-model="relacao.disciplina_id"
                @change="calcularCargaHoraria(relacao)"
                :disabled="editing || !relacao.turma_id"
                label="Selecione uma opção"
                dense
                solo
              />
            </ValidationProvider>
            <ValidationProvider
              v-else
              name="Disciplinas"
              :rules="relacao.is_polivalencia && !editing ? 'required' : ''"
              v-slot="{ errors }"
            >
              <e-label>Componentes Curriculares</e-label>
              <v-autocomplete
                @change="calcularCargaHoraria(relacao)"
                v-model="relacao.disciplinas_polivalencia"
                :item-value="(value) => value.id"
                :item-text="(val) => val.descricao"
                :items="disciplinasList"
                v-show="!editing"
                chips
                label="Selecione os Componentes Curriculares"
                multiple
                solo
                :error-messages="errors"
              ></v-autocomplete>

              <div v-show="editing" v-for="(item, index) in relacao.disciplinas" :key="index">
                <v-chip x-small>{{ item.descricao }}</v-chip>
              </div>
            </ValidationProvider>
          </v-col>
          <v-col cols="12" md="6" lg="3">
            <ValidationProvider name="Carga horária (horas)" rules="required" v-slot="{ errors }">
              <e-label>Carga horária <small>(horas)</small></e-label>
              <v-text-field
                type="number"
                v-model="relacao.carga_horaria"
                dense
                solo
                :error-messages="errors"
                min="0"
                readonly
                disabled
              />
            </ValidationProvider>
          </v-col>

          <v-col v-if="!editing" cols="12" lg="5">
            <v-card>
              <v-card-title>
                <e-label>Relação de Dias e Horários</e-label>
              </v-card-title>
              <v-card-text>
                <div v-if="relacoesDiasHorarios.length > 0">
                  <v-row>
                    <v-col cols="7" class="text-left">
                      <span class="text-uppercase">Horário</span>
                    </v-col>
                    <v-col cols="" class="text-left">
                      <span class="text-uppercase">Dia</span>
                    </v-col>
                  </v-row>
                  <v-list>
                    <v-list-item v-for="(item, i) in relacao.horarios" :key="i">
                      <v-row>
                        <v-col cols="7" class="text-left">
                          {{ item.horario.descricao }}
                        </v-col>
                        <v-col cols="5" class="text-left">
                          {{ item.dia.descricao }}
                        </v-col>
                      </v-row>
                    </v-list-item>
                  </v-list>
                </div>
                <div v-else>
                  <p class="text-center">Não há horários selecionados</p>
                </div>
                <v-btn
                  color="green white--text"
                  class="mt-3"
                  @click="alterRelacaoIdDialog(relacao)"
                  block
                >
                  {{ editing ? "Dias e horários" : "Dias e horários" }}
                </v-btn>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col v-if="editing" cols="12" lg="5">
            <v-card>
              <v-card-title>
                <e-label>Relação de Dias e Horários</e-label>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="7" class="text-left">
                    <span class="text-uppercase">Horário</span>
                  </v-col>
                  <v-col cols="" class="text-left">
                    <span class="text-uppercase">Dia</span>
                  </v-col>
                </v-row>
                <v-list>
                  <v-list-item v-for="(item, i) in relacoesDiasHorariosEdit" :key="i">
                    <v-row>
                      <v-col cols="7" class="text-left">
                        {{ item.horario.descricao }}
                      </v-col>
                      <v-col cols="5" class="text-left">
                        {{ item.dia.descricao }}
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list>
                <v-btn
                  color="green white--text"
                  class="mt-3"
                  @click="alterRelacaoIdDialog(relacao)"
                  block
                >
                  {{ editing ? "Dias e horários" : "Dias e horários" }}
                </v-btn>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" lg="5">
            <v-card>
              <v-card-title>
                <e-label>Quantidade de Aulas por etapa</e-label>
              </v-card-title>

              <v-card-text v-if="relacao.turma_id">
                <v-row>
                  <v-col
                    cols="6"
                    v-for="etapa in etapasBimestraisList"
                    :key="etapa.id"
                    class="pa-4"
                  >
                    <ValidationProvider
                      :name="`Aulas da etapa ${etapa.descricao}`"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        type="number"
                        min="0"
                        :label="`${etapa.descricao}`"
                        v-model="relacao.relacaoAulasEtapas[etapa.id]"
                        dense
                        :error-messages="errors"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-card-text>

              <div v-else class="pa-4">
                <p class="text-center">
                  <v-icon lg class="mr-2" color="primary">mdi mdi-alert</v-icon>
                  <span>Selecione uma turma primeiro!</span>
                </p>
              </div>
            </v-card>
          </v-col>

          <v-col cols="1">
            <v-btn
              v-if="relacoes.length > 1"
              color="error"
              type="button"
              @click="trashRelacao(relacoes, relacao)"
              :disabled="submittingForm"
              ><v-icon small>fa-trash</v-icon></v-btn
            >
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="d-flex justify-space-between">
            <div class="d-flex">
              <v-btn
                color="primary"
                :disabled="submittingForm"
                :loading="submittingForm"
                type="submit"
                >Enviar Dados</v-btn
              >
              <v-btn
                class="ml-3"
                v-if="!editing"
                color="secondary"
                type="button"
                @click="adicionarRelacao"
                :disabled="submittingForm"
              >
                Adicionar
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <v-dialog transition="dialog-top-transition" v-model="dialogVisible" max-width="800">
          <template>
            <v-card>
              <v-toolbar color="primary" dark
                >Vinculo de dias e horários
                <v-spacer></v-spacer>
                <v-btn icon @click="dialogVisible = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-row class="mt-4">
                  <v-col class="pt-0 pb-0" cols="4">
                    <e-label>Dias da semana</e-label>
                    <v-select
                      v-model="dia_da_semana"
                      :items="diasDaSemana"
                      :return-object="false"
                      :item-value="(value) => value"
                      :item-text="(value) => value.descricao"
                      dense
                      solo
                      label="selecione"
                    ></v-select>
                  </v-col>

                  <v-col class="pt-0 pb-0" cols="4">
                    <e-label>Horarios</e-label>
                    <v-select
                      v-model="horario_selecionado_id"
                      :items="horariosList"
                      :return-object="false"
                      :item-value="(value) => value"
                      :item-text="(value) => value.descricao"
                      dense
                      solo
                      label="selecione"
                    ></v-select>
                  </v-col>

                  <v-col class="pt-7 pb-0" cols="4">
                    <v-btn
                      :disabled="!dia_da_semana || !horario_selecionado_id"
                      color="green"
                      class="white--text"
                      @click="adicionarHorario(relacoes.indexOf(dialogVisibleRelacaoId))"
                      >+ adicionar</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card-text>

              <v-col v-if="!editing">
                <v-timeline
                  v-show="relacoes.indexOf(dialogVisibleRelacaoId) == item.relacao_id"
                  align-top
                  dense
                  v-for="(item, i) in relacoesDiasHorarios"
                  :key="i"
                >
                  <v-timeline-item
                    ><v-chip class="mt-1" color="green" text-color="white">
                      {{ item.dia.descricao }}
                      | {{ item.horario.descricao }}
                    </v-chip>
                    <v-btn
                      class="ml-2"
                      @click="deleteRelacaoDiaHorario(i, relacoes.indexOf(dialogVisibleRelacaoId))"
                      color="error"
                      fab
                      small
                      dark
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-timeline-item>
                </v-timeline>
              </v-col>
              <v-col v-if="editing">
                <v-timeline align-top dense v-for="(item, i) in relacoesDiasHorariosEdit" :key="i">
                  <v-timeline-item>
                    <v-chip class="mt-1" color="green" text-color="white">
                      {{ item.horario.descricao }} | {{ item.dia.descricao }}
                    </v-chip>

                    <v-btn
                      class="ml-2"
                      @click="deleteRelacaoDiaHorario(i, relacoes.indexOf(dialogVisibleRelacaoId))"
                      color="error"
                      fab
                      small
                      dark
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-timeline-item>
                </v-timeline>
              </v-col>
            </v-card>
          </template>
        </v-dialog>
      </form>
    </ValidationObserver>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import ELabel from "../../components/ELabel.vue";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      camposObrigatoriosNaoPreenchidos: false,
      carregandoDisciplinas: false,
      carregandoProfessores: false,
      carregandoTurmas: false,
      dia_da_semana: null,
      dialogVisible: false,
      dialogVisibleRelacaoId: 0,
      diasDaSemana: [
        { descricao: "Segunda", id: 0 },
        { descricao: "Terça", id: 1 },
        { descricao: "Quarta", id: 2 },
        { descricao: "Quinta", id: 3 },
        { descricao: "Sexta", id: 4 },
        { descricao: "Sábado", id: 5 },
      ],
      disciplinasList: [],
      etapasBimestraisList: [],
      form: {},
      horario_selecionado_id: null,
      horariosList: [],
      is_polivalencia: false,
      msgDiasEHorariosObrigatorios: false,
      professoresList: [],
      relacoes: [
        {
          disciplina_id: null,
          instrutor_id: null,
          is_polivalencia: false,
          relacaoAulasEtapas: {},
          relacoesDiasHorarios: [],
          tipo_professor: null,
          turma_id: null,
        },
      ],
      relacoesDiasHorarios: [],
      relacoesDiasHorariosEdit: [],
      selectMultiplo: false,
      submittingForm: false,
      tipos: [],
      turmasList: [],
    };
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
  },
  watch: {
    is_polivalencia(value) {
      this.selecionarVariasDisciplinas(value);
    },
    watch: {
      relacoes: {
        deep: true,
        handler(relacoes) {
          relacoes.forEach((relacao) => {
            if (relacao.is_polivalencia) {
              relacao.disciplina_id = null;
            } else {
              relacao.disciplinas_polivalencia = [];
            }
            this.calcularCargaHoraria(relacao);
          });
        },
      },
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async adicionarHorario(relacao) {
      if (!this.dia_da_semana || !this.horario_selecionado_id) {
        this.camposObrigatoriosNaoPreenchidos = true;
        return;
      }

      const data = {
        dia: this.dia_da_semana,
        horario: this.horario_selecionado_id,
        relacao_id: relacao,
      };

      if (!this.editing) {
        this.relacoesDiasHorarios.push(data);
        if (!this.relacoes[relacao].horarios) {
          this.relacoes[relacao].horarios = [data];
        } else {
          this.relacoes[relacao].horarios.push(data);
        }
      }
      if (this.editing) {
        this.relacoesDiasHorariosEdit.push(data);
      }

      this.camposObrigatoriosNaoPreenchidos = false;
    },
    async adicionarRelacao() {
      this.dia_da_semana = null;
      this.horario_selecionado_id = null;
      const novaRelacao = {
        carga_horaria: 0,
        disciplina_id: null,
        disciplinas_polivalencia: [],
        instrutor_id: null,
        is_polivalencia: false,
        relacaoAulasEtapas: {},
        relacoesDiasHorarios: [],
        tipo_professor: null,
        turma_id: null,
      };
      this.relacoes.push(novaRelacao);
    },
    alterRelacaoIdDialog(relacao) {
      this.dia_da_semana = null;
      this.horario_selecionado_id = null;
      this.dialogVisible = !this.dialogVisible;
      this.dialogVisibleRelacaoId = relacao;
      this.getHorariosDaTurma(relacao.turma_id);
    },
    calcularCargaHoraria(relacao) {
      if (!relacao.turma_id) {
        this.$set(relacao, "carga_horaria", 0);
        return;
      }

      const turma = this.turmasList.find((t) => t.id === relacao.turma_id);
      if (!turma) return;

      let seriesIds;
      if (turma.serie_id_list?.length) {
        seriesIds = turma.serie_id_list;
      } else if (turma.serie) {
        seriesIds = [turma.serie.id];
      } else {
        seriesIds = turma.series?.map((s) => s.id) || [];
      }

      if (!seriesIds.length) {
        this.$set(relacao, "carga_horaria", 0);
        return;
      }

      const getCarga = (disciplina) => {
        if (!disciplina?.series) return 0;

        return disciplina.series
          .filter((s) => seriesIds.includes(s.id))
          .reduce((acc, s) => {
            const cargaPivot = Number(s.pivot?.carga_horaria);
            const cargaDireta = Number(s.carga_horaria);
            let carga;
            if (!isNaN(cargaPivot)) {
              carga = cargaPivot;
            } else if (!isNaN(cargaDireta)) {
              carga = cargaDireta;
            } else {
              carga = 0;
            }

            return acc + carga;
          }, 0);
      };

      let total = 0;

      if (relacao.disciplina_id) {
        const disciplina = this.disciplinasList.find((d) => d.id === relacao.disciplina_id);
        total += getCarga(disciplina);
      }
      if (relacao.disciplinas_polivalencia?.length) {
        const disciplinasUnicas = [...new Set(relacao.disciplinas_polivalencia)];

        total += disciplinasUnicas.reduce((acc, disciplinaId) => {
          const disciplina = this.disciplinasList.find((d) => d.id === disciplinaId);
          return acc + getCarga(disciplina);
        }, 0);
      }
      this.$set(relacao, "carga_horaria", total);
    },
    deleteRelacaoDiaHorario(itemIndex) {
      const item = this.relacoesDiasHorarios[itemIndex];
      this.$modals.danger({
        buttons: [
          {
            callback: () => {
              this.$modals.close();
            },
            props: { color: "warning", small: true },
            text: "Cancelar",
          },
          {
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Deletando o vínculo");
              try {
                this.$toast.success("Vínculo deletado com sucesso");
                this.relacoesDiasHorarios.splice(itemIndex, 1);
                if (this.editing) {
                  this.relacoesDiasHorariosEdit.splice(itemIndex, 1);
                }
                this.relacoes.forEach((relacao) => {
                  if (relacao && relacao.horarios) {
                    const horarioIndex = relacao.horarios.findIndex(
                      (horario) => horario.relacao_id === item.relacao_id
                    );
                    if (horarioIndex !== -1) {
                      relacao.horarios.splice(horarioIndex, 1);
                    }
                  }
                });
                this.$forceUpdate();
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            disableIfCodeDoesntMatch: false,
            props: { color: "error", small: true },
            text: "Confirmar",
          },
        ],
        message: "Tem certeza que deseja apagar esse vínculo?",
        title: "Cuidado!",
      });
    },
    async getEtapasDaTurma(turma_id) {
      this.$loaderService.open("Carregando etapas");
      try {
        const response = await this.$services.etapasService.getEtapasBimestrais(turma_id);
        this.etapasBimestraisList = response;
        if (this.editing && this.relacoes[0]) {
          response.forEach((etapa) => {
            if (
              !Object.prototype.hasOwnProperty.call(this.relacoes[0].relacaoAulasEtapas, etapa.id)
            ) {
              this.$set(this.relacoes[0].relacaoAulasEtapas, etapa.id, "");
            }
          });
        }
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async getHorariosDaTurma(relacoes) {
      this.$loaderService.open("Carregando horários");
      try {
        if (relacoes.turma_id) {
          this.horariosList = await this.$services.horariosService.getHorariosDoTurnoDaTurma(
            relacoes.turma_id
          );
        }
      } catch (error) {
        this.$toast.error("Erro ao carregar horários", error);
      } finally {
        this.$loaderService.close();
      }
    },
    async loadData() {
      try {
        this.$loaderService.open("Carregando dados");
        this.disciplinasList = await this.$services.disciplinasService.syncAll();
        this.horariosList = await this.$services.horariosService.syncAll();
        this.professoresList = await this.$services.professoresService.syncAll();
        this.tipos = await this.$services.professoresService.tipos();
        this.turmasList = await this.$services.turmasService.syncAll();

        if (this.editing) {
          const vinculo = await this.$services.gestoesDeAulasService.gestaoGeralId(
            parseInt(this.$route.params.gestaoDeAulasId, 10)
          );

          this.form.is_polivalencia = vinculo.is_polivalencia;
          this.relacoesDiasHorariosEdit = vinculo.relacoesDiasHorarios ?? [];

          if (vinculo.tipo_professor) {
            this.form.tipo_professor = vinculo.tipo_professor;
          }
          if (vinculo) {
            this.form.instrutor_id = vinculo.instrutor_id;
            vinculo.relacaoAulasEtapas = vinculo.relacaoAulasEtapas || {};
            this.relacoes = [vinculo];
          }
          await this.getEtapasDaTurma(vinculo.turma_id);
          this.getHorariosDaTurma(vinculo.turma_id);
        }
        this.$loaderService.close();
        this.$forceUpdate();
      } catch (error) {
        this.$handleError(error);
      }
    },
    onChangePolivalencia(relacao) {
      if (relacao.is_polivalencia) {
        relacao.disciplina_id = null;
      } else {
        relacao.disciplinas_polivalencia = [];
      }
      this.calcularCargaHoraria(relacao);
    },
    async onChangeTurma(relacao) {
      await this.getEtapasDaTurma(relacao.turma_id);
      await this.getHorariosDaTurma(relacao);
      this.disciplinasList = await this.$services.disciplinasService.listarDisciplinasPorTurma(
        relacao.turma_id
      );
      relacao.carga_horaria = 0;
      relacao.disciplina_id = null;
      relacao.disciplinas_polivalencia = [];
    },
    async submitForm() {
      this.submittingForm = true;

      try {
        if (this.editing) {
          const formVinculo = {
            ...this.relacoes[0],
            instrutor_id: this.form.instrutor_id,
            relacoesDiasHorarios: this.relacoesDiasHorariosEdit,
            tipo_professor: this.form.tipo_professor,
          };

          if (formVinculo.relacoesDiasHorarios.length === 0) {
            this.$toast.danger("Preencha os campos obrigatórios: Dias da semana e Horários.");
            this.submittingForm = false;
            return;
          }

          await this.$services.gestoesDeAulasService.atualizar(formVinculo);
          this.$toast.success("Vínculo atualizado com sucesso!");
        }

        if (!this.editing) {
          const formRelacoes = this.relacoes.map((relacao, index) => ({
            ...relacao,
            instrutor_id: this.form.instrutor_id,
            is_polivalencia: relacao.is_polivalencia ? relacao.is_polivalencia : 0,
            relacoesDiasHorarios: this.relacoesDiasHorarios.filter((r) => r.relacao_id === index),
            tipo_professor: this.form.tipo_professor,
          }));

          if (formRelacoes.some((relacao) => relacao.relacoesDiasHorarios.length === 0)) {
            this.$toast.danger("Preencha os campos obrigatórios: Dias da semana e Horários.");
            this.submittingForm = false;
            return;
          }

          const responseData = await this.$services.gestoesDeAulasService.criar(formRelacoes);
          this.relacoes = responseData.filter((item) => item.errors);
          this.$toast.success("Vínculo(s) criado(s) com sucesso!");
        }

        if (this.relacoes.length === 0 || this.editing) {
          this.$toast.success("Vínculos criados/atualizados com sucesso");
          this.$router.push({ name: "gestoesDeAulas" });
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.submittingForm = false;
    },
    trashRelacao(relacoes, relacao) {
      this.relacoes.splice(this.relacoes.indexOf(relacao), 1);
      this.$toast.success("Relação deletada com sucesso!");
    },
  },
};
</script>

<style></style>
